import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import Sizes from '../definitions/Sizes';


function EqualWidthMessageColumns({
    columns,
    minimumColumnWidth = '14em',
    className,
    ...otherProps
}) {
    return (
        <Container
            className={classNames('rh-display-grid rh-pt-1 rh-box-sizing-border-box', className)}
            minimumColumnWidth={minimumColumnWidth}
            {...otherProps}
        >
            <For
                each="col"
                of={columns}
                index="index"
            >
                <span
                    key={`col-${index}`}
                    className={classNames('column-text rh-text-s rh-mb-1 rh-box-sizing-border-box', {
                        'rh-mb-0': !col },      // eliminates bottom margin when stacked if `col` is empty
                    )}
                >
                    {col}
                </span>
            </For>
        </Container>
    );
}

EqualWidthMessageColumns.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.node).isRequired,
    className: PropTypes.string,
    minimumColumnWidth: PropTypes.string,
};


const Container = styled.div`
    grid-template-columns: ${({ minimumColumnWidth }) => `repeat(auto-fit, minmax(${minimumColumnWidth}, 1fr))`};
    grid-gap: 0 ${Sizes.SPACING.ONE};
`;


export default EqualWidthMessageColumns;
